module.exports = __webpack_public_path__ + "static/Ausgov-Mono-b17085d2f1f819755bc25ad3bd53b46b.svg";